<template>
  <div class="tool" @click="$router.push('/topup');">
    <span class="num num-message">{{ userInfo.message_limit > 99 ? '99+' : userInfo.message_limit || 0 }}</span>
    <span class="num num-coin">{{ userInfo.coin  > 99 ? '99+' : userInfo.coin || 0 }}</span>
</div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['userInfo']),
  },
};
</script>
<style lang="less" scoped>
.tool {
  padding: 0 16px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 30px;
  display: flex;
  height: 32px;
  line-height: 32px;
  font-size: @fontSmall;
  margin-left: auto;
  .num {
    display: flex;
    align-items: center;
    &::before {
      content: '';
      width: 16px;
      height: 16px;
      background: url(@/assets/images/icon/coin.png) no-repeat center;
      background-size: 100%;
      margin-right: 5px;
    }
    &.num-message {
      margin-right: 10px;
      &::before {
        background: url(@/assets/images/icon/message.png) no-repeat center;
        background-size: 100%;
      }
    }
  }
}
</style>
